import { useFieldApi } from '@data-driven-forms/react-form-renderer';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useMemo } from 'react';

import Radio from '~/common/mui/Radios/MUIRadioGroup/Radio';
import type { EventFor } from '~/common/util/types/events';

type RadioButtonProps = {
  onBlur?: (e: EventFor<'button', 'onBlur'>) => void;
  onFocus?: (e: EventFor<'button', 'onBlur'>) => void;
  onChange?: (e: EventFor<'input', 'onChange'>) => void;
  name: string;
  id?: string;
  label?: string;
  value: string;
  groupName: string;
  sx?: any;
  isDisabled?: boolean;
};

export default function RadioButton({
  onBlur,
  onFocus,
  onChange,
  value,
  id,
  name,
  groupName,
  label,
  sx,
  isDisabled = false,
  ...props
}: Readonly<RadioButtonProps>) {
  const radioGroupName = useMemo(() => {
    const path = name.replace(/\..+$/, '');
    return `${path}.${groupName}`;
  }, [groupName, name]);

  const { input, meta } = useFieldApi({
    ...props,
    name: radioGroupName,
  });

  return (
    <FormControlLabel
      id={id}
      label={label}
      value={value}
      sx={sx}
      disabled={isDisabled}
      control={
        <Radio
          name={radioGroupName}
          data-testid={`${name}-${value}`}
          error={meta.invalid}
          checked={input.value == value}
          onBlur={(e) => {
            input.onBlur(e);
            onBlur?.(e);
          }}
          onFocus={(e) => {
            input.onFocus(e);
            onFocus?.(e);
          }}
          onChange={(e) => {
            input.onChange(e);
            onChange?.(e);
          }}
        />
      }
    />
  );
}
